import { Toast, Dialog } from 'vant'
import dsBridge from 'dsbridge'

export default {
  methods: {
    _formatDate(datep) {
      const seperator1 = '-'
      const date = new Date(datep)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      return year + seperator1 + month + seperator1 + strDate
    },

    _getAppVersion() {
      // 获取应用版本
      return this.$dsBridge.call('syn.getAppVersionCode', '')
    },

    // 设置人脸识别的
    _setLiveDetectionConfig(func) {
      this.$dsBridge.call(
        'asyn.setLiveDetectionConfig',
        '{"isByOrder":false,"numOfLiveness":1,"arrayAction":[0]}',
        res => {}
      )
    },

    /**
     * 显示一个alert
     * @param msg
     * @param confirm 确认时回调
     * @private
     */
    _showAlert(msg, confirm) {
      Dialog.alert({
        message: msg,
        confirmButtonText: this.$t('confirm')
      }).then(confirm)
    },

    _showConfirm(msg, confirm, cancel) {
      Dialog.confirm({
        title: this.$t('confirm'),
        message: msg
      })
        .then(confirm)
        .catch(cancel)
    },

    // 清空浏览器历史记录
    _clearHistory() {
      this.$dsBridge.call('jsapi.clearHistory', '')
    },

    _routeReplace(toName, params) {
      this.$router.replace({
        name: toName,
        params: params
      })
    },

    _routePush(toName, params) {
      this.$router.push({
        name: toName,
        params: params
      })
    },

    /**
     * 路由跳转带有query参数
     */
    _routePushQ(toName, params) {
      this.$router.push({
        name: toName,
        query: params
      })
    },

    /**
     * @param func
     * @private
     */
    _addOnBackListener(func) {
      if (func) {
        window.addEventListener('popstate', func)
      }
    },

    /**
     * @param func
     * @private
     */
    _removeOnBackListener(func) {
      if (func) {
        window.removeEventListener('popstate', func)
      }
    },

    /**
     * @param number
     * @returns {boolean}
     * @private
     */
    _isValidPhoneNo(number) {
      if (number) {
        try {
          const numStr = String(number)
          return numStr.startsWith('09')
        } catch (e) {
          console.error('error', e)
        }
      }
      return false
    },

    _event(event) {
      this.$dsBridge.call('syn.event', event)
    },

    /**
     * 是否是在App里面
     * @returns {*|boolean}
     */
    _isApp() {
      if (this.$dsBridge && !!this.$dsBridge.call('jsapi.isApp', '')) {
        return true
      } else {
        return false
      }
    },
    /**
     * 是否是在webview里面,封装一个通用的检测方法
     * @returns {*|boolean}
     */
    _isInWebView() {
      const ua = navigator.userAgent || navigator.vendor || window.opera

      const isIOSWebView = /iPhone|iPad|iPod/.test(ua) && /AppleWebKit/.test(ua) && !/Safari/.test(ua)
      const isAndroidWebView = /Android/.test(ua) && /; wv/.test(ua)
      const isHistoryWebView = window.history.length === 1
      const hasWebViewAPI = !!(window.ReactNativeWebView || window.webkit)

      return isIOSWebView || isAndroidWebView || isHistoryWebView || hasWebViewAPI
    },

    /**
     * 判读是否是测试环境
     * */
    _isTest() {
      return process.env.NODE_ENV !== 'production'
    },
    /**
     * 检测是否登录，没有的话跳到登录页面，
     * 已登录的话执行call
     * @param call
     */
    _loginOr(call) {
      if (this.$http.isLogin()) {
        if (call && typeof call === 'function') {
          call()
        }
      } else {
        this._routerLogin()
      }
    },

    _getVersionNumber() {
      const v = this.$dsBridge.call('syn.getAppVersionCode', '')
      if (v) {
        return parseInt(v)
      }
      return 0
    },

    // 重新登陆
    _routerLogin() {
      this._routePush('LogoutPage')
    },

    /**
     * 显示Toast
     */
    _showToast(msg) {
      Toast(msg)
    },

    /**
     * 判断字符串是否为空
     * */
    _isEmptyStr(str) {
      if (typeof str === 'undefined' || str == null || str === '') {
        return true
      }
      return false
    },

    /** *
     * 用于把对象装成url格式
     * */
    _getUrlFormtObj(obj) {
      const params = []
      Object.keys(obj).forEach(key => {
        let value = obj[key]
        if (typeof value === 'undefined') {
          value = ''
        }
        params.push([key, encodeURIComponent(value)].join('='))
      })
      return params.join('&')
    },

    /**
     * 显示打钩消息
     */
    _showSuccess(msg) {
      Toast.success(msg)
    },

    /**
     * 路由回退或者历史回退
     */
    _routerBack() {
      this.$router ? this.$router.back() : window.history.back()
    },

    /**
     * 会到Home
     */
    _routerHome() {
      this._routePush('home')
    },

    /**
     * setting
     */
    _routerSetting() {
      this._routePush('settings')
    },
    /**
     * 显示Loading
     */
    _showLoading(config = { num: 0, overlay: true }) {
      return Toast.loading({
        duration: config.num,
        message: 'Loading...',
        forbidClick: true,
        loadingType: 'spinner',
        overlay: config.overlay
      })
    },

    /**
     * 不显示Loading
     */
    _dismissLoading() {
      Toast.clear()
    },

    // 将base64文件转换为二进制
    _dataURLtoBlob(dataUrl) {
      const arr = dataUrl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },

    /**
     * 刷新通用参数列表
     * @private
     */
    _reloadParamString() {
      // 从Android接口获取通用参数
      const paramString = this.$dsBridge.call('syn.getParamString', '')
      if (paramString) {
        // 保存通用参数，下次就可以节省时间
        window.localStorage.setItem('paramString', paramString)
      }
    },

    // 跳转浏览器
    _startViewAction(url) {
      this.$dsBridge.call('syn.startViewAction', url)
    },

    _exitApp() {
      this.$dsBridge.call('syn.exitApp', '')
    },

    _isRouterFrom(names) {
      try {
        const p = localStorage.getItem('fromPage')
        return names.find(arg => {
          return p === arg
        })
      } catch (e) {
        console.error('error', e)
      }
      return false
    },

    // 平滑滚动到某个控件
    _scrollViewToShow(view) {
      if (view) {
        view.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },

    // 保存object到json的localstorage
    _saveLSObject(key, object) {
      if (key && object) {
        try {
          const jsonStr = JSON.stringify(object)
          localStorage.setItem(key, jsonStr)
        } catch (e) {
          console.error('error', e)
        }
      }
    },

    // 从localstorage 加载object
    _loadLSObject(key) {
      if (key) {
        try {
          const jsonStr = localStorage.getItem(key)
          return JSON.parse(jsonStr)
        } catch (e) {
          console.error('error', e)
        }
      }
      return null
    },

    // 将数组随机乱序
    _arrayShuffle(src) {
      const arr = [...src]
      try {
        let i = arr.length
        while (i) {
          const j = Math.floor(Math.random() * i--)
          ;[arr[j], arr[i]] = [arr[i], arr[j]]
        }
      } catch (e) {
        console.error('error', e)
      }
      return arr
    },
    _randomPhoneNum() {
      const $chars = '1234567890'
      const maxPos = $chars.length
      let pwd = ''
      for (let i = 0; i < 8; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return '09' + pwd
    },
    _postEvents(eventKey, eventValue) {
      this.$http({
        method: 'post',
        url: this.$urls.events.POST_EVENT_URL,
        data: {
          event_name: eventKey,
          event_value: eventValue
        }
      })
        .then(res => {})
        .catch(err => {
          console.error('error', err)
        })
    },

    isNumber(val) {
      var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true
      } else {
        return false
      }
    },
    // 去左右空格;
    _trim(s) {
      return s.replace(/(^\s*)|(\s*$)/g, '')
    },

    _routeReplaceQ(toName, params) {
      this.$router.replace({
        name: toName,
        query: params
      })
    },

    _checkEmailReg(email) {
      const emreg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      return emreg.test(email.trim())
    },

    _saveToNative(key, value) {
      const json = {
        key: key,
        value: value
      }
      this.$dsBridge.call('jsapi.save2Sp', JSON.stringify(json))
    },

    _getString4Native(key) {
      const value = this.$dsBridge.call('jsapi.get4Sp', key)
      return value
    },

    _clearNativeSp() {
      this.$dsBridge.call('jsapi.clearSp', '')
    },

    _getKeyParams4Url(url, key) {
      const arr = url.split('?')
      if (arr && arr.length > 1) {
        const res = arr[1].split('&')
        const items = {}
        for (let i = 0; i < res.length; i++) {
          const a = res[i].split('=')
          items[a[0]] = a[1]
        }
        return items[key]
      }
    },

    _getFcmTokenAndPush() {
      // const fcm_token = this.$dsBridge.call('jsapi.get4Sp', this.$ConstData.STORAGE.FCM_TOKEN)
      // if (!fcm_token) {
      //   this.$dsBridge.call('jsapi.createToken', '')
      //   setTimeout(() => {
      //     const fcm_token = this.$dsBridge.call('jsapi.get4Sp', this.$ConstData.STORAGE.FCM_TOKEN)
      //     PostFcmToken({
      //       token: fcm_token
      //     }).then(res => {
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   }, 5000)
      // } else {
      //   PostFcmToken({
      //     token: fcm_token
      //   }).then(res => {
      //   })
      // }
    },

    _trimObject(obj) {
      if (Object.prototype.toString.call(obj).toLowerCase() === '[object object]') {
        for (const key in obj) {
          if (Object.prototype.toString.call(obj[key]).toLowerCase() === '[object object]') {
            this._trimObject(obj[key])
          } else if (Object.prototype.toString.call(obj[key]).toLowerCase() === '[object string]') {
            console.log('obj[key]1 =' + obj[key])
            obj[key] = this._trim(obj[key])
            console.log('obj[key]2 =' + obj[key])
          }
        }
      }
    },

    // 判断是否全部一样
    _isAllSame(pin) {
      return pin.split('').every(c => c === pin[0])
    },

    // 判断是否连续数字（递增或递减）
    _isSequential(pin) {
      return pin.split('').every((c, i, arr) => {
        if (i === 0) return true
        return (
          Number(arr[i]) - Number(arr[i - 1]) === 1 || // 递增
          Number(arr[i]) - Number(arr[i - 1]) === -1 // 递减
        )
      })
    },
    _log(val) {
      if (process.env.NODE_ENV === 'production') {
        return
      }
      console.log('xiuer--->')
      console.log(val)
    },

    _hasJsBridge() {
      return dsBridge.hasNativeMethod('jsapi.getVersionCode') && dsBridge.call('jsapi.getVersionCode', '')
    },

    _copyText(text) {
      if (!text) {
        this.$toast(this.$t('copy_fail'))
        return
      }
      // 创建临时textarea元素
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed' // 防止页面滚动
      document.body.appendChild(textarea)
      // 选中文本
      textarea.select()

      try {
        // 执行复制命令
        const successful = document.execCommand('copy')
        if (successful) {
          this.$toast(this.$t('copy_success'))
        } else {
          throw new Error()
        }
      } catch (err) {
        this.$toast(this.$t('copy_fail'))
      }
      // 移除临时元素
      document.body.removeChild(textarea)
    },
    _isAndroid() {
      const u = navigator.userAgent
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        return true
      }
      return false
    },

    _isIOS() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      return isiOS
    },

    _formatAmount(amount) {}
  }
}
